export default {
  title: '忘记密码',
  rememberText: '记起密码？',
  rememberLinkText: '立即登录',
  sendemail: {
    labelText: '已向您的邮箱发送链接',
    remindText:
      '激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。',
    checkButtonText: '查看邮箱',
    homeButtonText: '返回首页',
  },
  form: {
    mail: {
      placeHolder: '请输入邮箱地址',
      required: '邮箱地址不能为空',
      formatVeryfy: '请输入有效邮箱地址',
    },
    code: {
      required: '验证码不能为空',
    },
    submitText: '找回密码',
  },
}
